const APP_KEY = "douhao1p4";
// const APP_KEY = "spark";
const WEB_CODE = "1";
const ali_accessKeyId = 'LTAI5tAPox85bwKGTdgL9wcp';
const ali_accessKeySecret = 'gPoCfgQUmfcm5X5eeqfd7AjucIyoF0';
const ali_bucket = 'spark-app';
const ali_region = 'oss-cn-qingdao';
const ali_tmpimg_path = 'xixin/tianyuan/';

const ali_header_url = 'https://spark-app.oss-cn-qingdao.aliyuncs.com/';

const API_URL="https://xixin.gamepku.com";
const FILE_URL = 'https://xixin.gamepku.com/files/';
const groupId = 'xixin';


 // const API_URL = 'http://testxixin.gamepku.com';
 // const FILE_URL = 'http://testxixin.gamepku.com/files/';
 // const groupId = 'testxixin';

// const API_URL="https://testgamepku.gamification.org.cn";
// const ali_sb3_path = 'testaimake/zuopin/';
// const ali_accessKeyId = 'LTAI5tAPox85bwKGTdgL9wcp';
// const ali_accessKeySecret = 'gPoCfgQUmfcm5X5eeqfd7AjucIyoF0';
// const ali_bucket = 'spark-app';
// const ali_region = 'oss-cn-qingdao';
export {
    APP_KEY,
    API_URL,
    FILE_URL,
    WEB_CODE,
    ali_accessKeyId,
    ali_accessKeySecret,
    ali_bucket,
    ali_region,
    ali_tmpimg_path,
    ali_header_url,
    groupId
}
